module.exports = __webpack_public_path__ + "img/close.c9db6981.svg";